import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.span<{
  $overdue?: boolean;
  $lastWeek?: boolean;
  $isCompleted?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ theme }) => `0 ${theme.spacing(1)}`};

  overflow: hidden;
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.grey[100]};
  transition: color 200ms;

  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $lastWeek, theme }) =>
    $lastWeek &&
    css`
      color: ${theme.palette.warning.main};
    `};

  ${({ $overdue, theme }) =>
    $overdue &&
    css`
      color: ${theme.palette.error.dark};
    `};

  ${({ $isCompleted, theme }) =>
    $isCompleted &&
    css`
      color: ${theme.palette.text.secondary};
    `};
`;

export const IconContainer = styled.span`
  font-size: 1rem;
  line-height: 62.5%;
`;

export const Label = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
